module.exports = __webpack_public_path__ + "img/email-blue.30bdbad6.svg";